var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#69728B",
  fillRule: "evenodd",
  d: "M14.252 13.75h-2.447a.75.75 0 0 1-.394-.122L8.542 11.65H8.13v5.175a.71.71 0 0 1-.675.675H4.042a.71.71 0 0 1-.703-.703V11.65h-.122a.7.7 0 0 1-.712-.713V5.314a.703.703 0 0 1 .712-.75h5.325l2.87-1.941a.75.75 0 0 1 .393-.122h2.447a.713.713 0 0 1 .703.703V4.94a3.244 3.244 0 0 1 0 6.333v1.736a.71.71 0 0 1-.703.741M3.928 10.244h-.007V5.969h4.837a.7.7 0 0 0 .394-.122l2.869-1.94h1.528v8.437H12.02l-2.87-1.978a.7.7 0 0 0-.393-.122H4.157a.7.7 0 0 0-.229 0m.818 1.406v4.472h2.006V11.65zm10.209-1.698V6.26q.06.011.12.026a1.875 1.875 0 0 1-.12 3.666",
  clipRule: "evenodd"
})));
export default SvgReport;